// extracted by mini-css-extract-plugin
module.exports = {"container":"Stocks_container__20Kbo","overflowContainer":"Stocks_overflowContainer__10Ghg","stats":"Stocks_stats__dKi3R"};